import { AxiosResponse } from 'axios';
import { all, fork, put, takeEvery } from 'redux-saga/effects';
import { Notification } from 'api';
import { api } from 'api';
import { mapNotificationApiToStore } from '../../utils/mappers/notificationMapper';
import { apiResError } from '../actions';
import * as actionType from './actionTypes';
import * as action from './actions';

function* getUserNotifications() {
	try {
		const response: AxiosResponse<Notification[]> =
			yield api.utils.apiUtilsGetNotificationMessagesGet();
		const notifications = mapNotificationApiToStore(response.data);
		if (notifications.length > 0) {
			// yield put(action.updateSeenStatus(false))
			yield put(action.getUserNotificationsSuccess(notifications));
		} else {
			// yield put(action.updateSeenStatus(true));
			yield put(action.getUserNotificationsSuccess([]));
		}
	} catch (error: any) {
		yield put(apiResError(error.message));
	}
}

export function* watchGetUserNotifications() {
	yield takeEvery(actionType.GET_USER_NOTIFICATIONS, getUserNotifications);
}

function* notificationSaga() {
	yield all([fork(watchGetUserNotifications)]);
}

export default notificationSaga;
